import React from 'react';
import CustomReportSearchModalTable from './CustomReportSearchModalTable';
import { CustomReportSearchModalProvider } from './useCustomReportSearchModal';

const CustomReportSearchModal = ({ data = {} }) => {
  return (
    <CustomReportSearchModalProvider data={data}>
      <CustomReportSearchModalTable />
    </CustomReportSearchModalProvider>
  );
};

export default CustomReportSearchModal;